import React from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { applyEffect } from './effect';
import { navigate } from './router';

// Assign to change url with effect
const assign = to => {
  applyEffect(to);
  navigate(to);
};

// Component to do a link with effect
const Link = withRouter(({ children, to, disabled, className, location }) => {
  const onClick = () => applyEffect(to);
  const route = to;

  return (
    <RouterLink
      to={{
        pathname: route,
        search: location.search || ''
      }}
      onClick={onClick}
      disabled={disabled}
      className={className}
    >
      {children}
    </RouterLink>
  );
});

export { Link, assign };
